/* eslint-disable react-hooks/rules-of-hooks */
import React, { useMemo, useState } from 'react';
import { connect, useIntl, useDispatch, getLocale } from 'umi';
import { Layout, Justify, Segment, Row, Col } from 'tea-component';
import KeyPerformanceMetrics from '@/pages/dashboard/pages/overview/components/KeyPerformanceMetrics';
import BreakdownContext from '@/pages/dashboard/pages/overview/components/BreakdownContext';
import CountriesContext from '@/pages/dashboard/pages/overview/components/CountriesContext';
import DailyFilter from '@/pages/dashboard/filterPageComponents/overview/dailyFilterNew';
import { DATE_DIMENSION,FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import useDailyRegionModel from '@/pages/dashboard/servicesModels/overview/dailyRegionModel';
import useDailyMetricsModel from '@/pages/dashboard/servicesModels/overview/dailyMetricsUserModel';
import useEventData from  '@/pages/dashboard/servicesModels/overview/overviewEventDataModel';
import OverviewTable from '@/pages/dashboard/pages/overview/components/OverviewTable';
import EngagementRevenueMetrics from '@/pages/dashboard/pages/overview/components//EngagementRevenueMetrics/EngagementRevenueMetrics';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { useBuriedPoint } from '@/pages/home/utils/customHook';
import GuideOverviewDaily from '@/pages/dashboard/components/UserGuide/OverviewDaily';
import MarqueeInfo from '@/pages/dashboard/components/MarqueeInfo';

import '@/pages/dashboard/assets/scss/page/Overlay/index.scss';
import { SubTitle } from '@/pages/dashboard/components/SubTitle';

const { Content } = Layout;

const dailyAcc = (props: any) => {
  const { gameCode, explainInfo, gameConfig, timeZone = 0 } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl(); // 中英切换方法
  const { getLocalText } = useLocal();
  const isEN = getLocale() === 'en-US';
  const [formValue, setFormValue] = useState<any>({
    filterValue: null,
    newFilter: true,
    timeType: 'Day',
    [FORM_MAP.RANGE_TIME_DIFF]: true,
  });
  const { rangeTime } = formValue?.filterValue ?? [];
  const [filterLoading, setFilterLoading] = useState(true);
  const [regionDataType, setRegionDataType] = useState('country');

  // 事件类型
  const regionData = useDailyRegionModel(
    props,
    formValue,
    dispatch,
    filterLoading,
    regionDataType,
    'acc'
  );
  const metricsData = useDailyMetricsModel(
    props,
    formValue,
    dispatch,
    filterLoading,
    regionDataType,
    'acc'
  );

  const [eventData, loading] = useEventData(
    gameCode,
    formValue,
    filterLoading,
  );

  // Countries / Area Breakdown
  const COUNTRY_AREA_ZONE = [
    {
      text: formatMessage({ id: 'overview_area_tab_country' }),
      value: 'country',
    },
    {
      text: formatMessage({ id: 'overview_area_tab_region' }),
      value: 'region',
    },
    { text: formatMessage({ id: 'overview_area_tab_zone' }), value: 'zone' },
    { text: formatMessage({ id: 'common_Channel' }), value: 'channel' },
    { text: formatMessage({ id: 'overview_area_tab_os' }), value: 'os' },
  ];

  // 打点
  const logObj = {
    pageId: '203701',
    pageName: 'overviewDailyAcc',
    extInfo: 'overviewDailyAcc',
    pagePath: '/overview/acc-daily',
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };

  useBuriedPoint(logObj);

  const handleConfirm = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
  };

  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
    setFilterLoading(false);
  };

  // Countries / Area Breakdown模块change方法；
  const changeBreakdown = useMemo(
    () => (val: any) => {
      setRegionDataType(val);
    },
    [formValue, gameCode, filterLoading],
  );

  return (
    <Content className="dbd-scorll-body">
      <Content.Header
        title={
          <div className="page-title">
            {formatMessage({ id: 'overview_daily_Daily' })}
          </div>
        }
        subtitle={<SubTitle/>}
      ></Content.Header>
      <Content.Body full>
        <MarqueeInfo pagePath={'/overview/daily'} />
        <DailyFilter
          openSticky={true}
          formValue={formValue}
          timeZone={timeZone}
          filterConfirm={handleConfirm}
          filterReset={handleConfirm}
          buttonLogConfig={{
            pageId: '203701',
            confirmButtonId: '203701001',
            resetButtonId: '203701002',
          }}
          filterLoading={filterLoading}
          setFilterLoading={setFilterLoading}
          filterInit={handleInit}
        />
        <Justify
          className="overlay-margin"
          left={
            <div className="overlay-title">
              {getLocalText('overview_Key_Performance_Metrics')}
            </div>
          }
          right={
            <div className="overlay-time">
              {rangeTime?.length > 1
                ?  `${rangeTime[0]} ${rangeTime[1] && (rangeTime[1] !== rangeTime[0]) ? ` ~ ${rangeTime[1]}` : ""}`
                : ''}
            </div>
          }
        />
        <KeyPerformanceMetrics
          newFilter
          parentProps={props}
          formValue={formValue}
          dispatch={dispatch}
          filterLoading={filterLoading}
          gameCode={gameCode}
          explainInfo={explainInfo}
          dailyReqType='acc'
          dateDimension={DATE_DIMENSION.DAY}
        />
        <Row className="margin-t-10">
          <Col>
            <EngagementRevenueMetrics
              eventData={eventData}
              loading={loading}
              renderIndex={0}
              gameCode={gameCode}
              filterLoading={filterLoading}
              formValue={formValue}
              explainInfo={explainInfo}
              placeholderId={'overview-daily-key-metrics'}
              type={DATE_DIMENSION.DAY}
              dailyReqType='acc'
            />
          </Col>
          <Col>
            <EngagementRevenueMetrics
              eventData={eventData}
              loading={loading}
              renderIndex={1}
              gameCode={gameCode}
              filterLoading={filterLoading}
              formValue={formValue}
              explainInfo={explainInfo}
              type={DATE_DIMENSION.DAY}
              dailyReqType='acc'
            />
          </Col>
        </Row>
        <Row className="margin-t-10">
          <Col>
            <OverviewTable
              tableType='day'
              filterValue={formValue}
              filterLoading={filterLoading}
              gameConfig={gameConfig}
              gameCode={gameCode}
              explainInfo={explainInfo}
              dailyReqType='acc'
            />
          </Col>
        </Row>
        <Row className="margin-t-10">
          <Col>
            <BreakdownContext
              componetIndex={0}
              data={metricsData}
              gameCode={gameCode}
              type={DATE_DIMENSION.DAY}
              formValue={formValue}
            />
          </Col>
          <Col>
            <BreakdownContext
              componetIndex={1}
              data={metricsData}
              gameCode={gameCode}
              type={DATE_DIMENSION.DAY}
              formValue={formValue}
            />
          </Col>
        </Row>
        <Justify
          className="overlay-margin-breakdown"
          left={
            <Segment
              className={
                isEN ? 'segment-light' : 'segment-light segment-light-china'
              }
              options={COUNTRY_AREA_ZONE}
              defaultValue={'country'}
              onChange={changeBreakdown}
            />
          }
        />
        {/* 只有三个，没必要map */}
        <Row>
          <Col className="margin-b-10">
            <CountriesContext
              index={0}
              regionDataType={regionDataType}
              data={regionData}
              formValue={formValue}
              activeUserType="DAU"
              type="DAU"
              gameCode={gameCode}
            />
          </Col>
        </Row>
        <Row>
          <Col className="margin-b-10">
            <CountriesContext
              index={1}
              regionDataType={regionDataType}
              data={regionData}
              formValue={formValue}
              activeUserType="DAU"
              type="Revenue"
              gameCode={gameCode}
            />
          </Col>
        </Row>

        <Row>
          <Col className="margin-b-10">
            <CountriesContext
              index={2}
              regionDataType={regionDataType}
              data={regionData}
              formValue={formValue}
              activeUserType="DAU"
              type="New"
              gameCode={gameCode}
            />
          </Col>
        </Row>
        <GuideOverviewDaily/>
      </Content.Body>
    </Content>
  );
};

export default connect((state: any) => ({
  serviceData: state.overview?.data,
  gameCode: state.dashboard?.currentGame?.game_code,
  explainInfo: state.dashboard?.explainInfo,
  gameConfig: state.dashboardSetting?.gameConfig,
  timeZone: parseInt(state?.dashboardSetting?.gameConfig?.time_zone || '') || 0
}))(dailyAcc);